<script setup lang="ts">
interface Props {
  src?: string
  alt?: string
}

const props = defineProps<Props>()

const loaded = ref(false)

watch(() => props.src, () => {
  loaded.value = false
})

function onLoad() {
  loaded.value = true
}
</script>

<template>
  <div class="smooth-image">
    <div v-if="!loaded" class="smooth-image-skeleton" />

    <img
      v-if="src"
      :src="src"
      :alt="alt"
      class="smooth-image-img"
      :class="{ 'smooth-image-img--loaded': loaded }"
      @load="onLoad"
    >
  </div>
</template>

<style scoped lang="scss">
.smooth-image {
  @apply relative w-full h-full overflow-hidden;
}

.smooth-image-skeleton {
  @apply absolute inset-0 w-full h-full overflow-hidden;
  background-color: #e4e4e4;

  &::after {
    @apply absolute inset-0 w-full h-full;
    content: '';
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: smooth-image-shimmer 1.5s infinite;
  }
}

.smooth-image-img {
  @apply relative w-full h-full object-cover object-center;
  opacity: 0;
  transition: opacity 0.4s ease;

  &--loaded {
    opacity: 1;
  }
}

@keyframes smooth-image-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
